<div class="conversation-thread">
  <!-- Header -->
  <div class="thread-header">
    <button class="back-button" (click)="onBack()">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>

    <div class="thread-header-info">
      <div class="thread-avatars">
        @for (p of participants; track p.name) {
          <div class="avatar" [attr.data-color]="p.color">
            {{ p.initials }}
          </div>
        }
      </div>
      <div class="thread-title-section">
        <div class="thread-title">{{ conversationTitle }}</div>
        <div class="thread-participants">{{ participants.length }} participants</div>
      </div>
    </div>

    <button class="thread-menu-button">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
        />
      </svg>
    </button>
  </div>

  <!-- Messages -->
  <div class="thread-messages" #threadMessages>
    @for (message of messages; track message.id; let i = $index) {
      <!-- Date separator -->
      @if (i === 0 || message.date !== messages[i - 1].date) {
        <div class="date-separator">
          {{ message.date }}
        </div>
      }

      <!-- Message bubble -->
      <div class="message-wrapper" [class.own]="message.isOwn">
        @if (!message.isOwn) {
          <div class="message-avatar" [attr.data-color]="message.color">
            {{ message.initials }}
          </div>
        }

        <div class="message-bubble">
          @if (!message.isOwn) {
            <div class="message-author">{{ message.author }}</div>
          }
          <div class="message-content">{{ message.content }}</div>
          <div class="message-time">{{ message.timestamp }}</div>
        </div>
      </div>
    }
  </div>

  <!-- Input -->
  <div class="thread-input">
    <button class="attach-button">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
        />
      </svg>
    </button>

    <input type="text" [(ngModel)]="newMessage" (keydown.enter)="sendMessage()" placeholder="Écrire un message..." />

    <button class="send-button" [disabled]="!newMessage.trim()" (click)="sendMessage()">
      <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
      </svg>
    </button>
  </div>
</div>
